import { isDefined, isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { VideoRef } from "../../player/MediaResource.js";
import { AdUnit } from "../AdUnit.js";
import { AbstractPrebidModule, PrebidModule } from "./PrebidModule.js";

export interface PrebidModuleWithAdsManagerOps extends PrebidModule {




    
    beforeAdManagerStart(g: typeof google, adUnit: AdUnit, 
                            adsManager: google.ima.AdsManager, 
                            resource: VideoRef
                        ): Promise<void>;
    


}


export function isPrebidModuleWithAdsManagerOps(x: any): x is PrebidModuleWithAdsManagerOps {
    return isDefined(x) && ("beforeAdManagerStart" in x) && isFunction(x.beforeAdManagerStart);
}


export abstract class AbstractPrebidModuleWithAdsManagerOps<X> extends AbstractPrebidModule<X> implements PrebidModuleWithAdsManagerOps{


    beforeAdManagerStart(g: typeof google, adUnit: AdUnit, adsManager: google.ima.AdsManager, resource: VideoRef): Promise<void> {
        return this.internalLoadOps().then(sdk => {
            return this.beforeAdManagerStartInternalOps(sdk,g,adUnit,adsManager,resource);
        }).catch(e => {
            console.log("HB - There was an error in prebidding",e);
            return Promise.resolve();
        })
    }


    protected abstract beforeAdManagerStartInternalOps(sdk: X, g: typeof google, adUnit: AdUnit, adsManager: google.ima.AdsManager, resource: VideoRef): Promise<void>;

}


